// src/components/upload/UploadImage.jsx
import { Upload } from "antd";
import React from "react";

import { BeforeUpload } from "./utils/BeforeUpload";
import { compressImage } from "./utils/compressImage";
import { useToast } from "../toast";
import api from "../../api";
import styles from "../styles.module.scss";

const UploadImage = ({
  title,
  required = false,
  value,
  onUpload,
  maxCount = 1,
}) => {
  const toast = useToast();
  const beforeUpload = BeforeUpload();

  const files = value
    ? [{ uid: "-1", name: "image.jpg", status: "done", url: value }]
    : [];

  return (
    <div className="d-flex flex-column gap-1">
      {title && (
        <div className={styles.title}>
          {required && <span>*</span>}
          {title}
        </div>
      )}
      <Upload
        listType="picture-card"
        accept="image/png,image/jpeg" // ✅ зөвшөөрсөн төрлүүд
        maxCount={maxCount}
        fileList={files}
        beforeUpload={beforeUpload}
        onRemove={() => onUpload("")}
        customRequest={async ({ file, onSuccess, onError }) => {
          try {
            // ✅ Харьцаа эвдэхгүй, JPEG болгож шахна
            const compressed = await compressImage(file, {
              maxWidth: 1920,
              maxHeight: 1920,
              maxSizeMB: 0.5, // илүү жижиг зорилт (ж/н 0.5MB)
              mimeType: "image/jpeg",
              initialQuality: 0.82, // багаас эхэлнэ
              neverBiggerThanOriginal: true,
              //   maxSizeMB: 0.7, // зорилтот хэмжээ
              //   mimeType: "image/jpeg", // гаралт
              //   initialQuality: 0.9,
              //   step: 0.1,
            });

            const formData = new FormData();
            // console.log("formData --->", formData);
            formData.append("image", compressed);
            // console.log("compressed --->", compressed);

            const res = await api.upload_image(formData);
            // console.log("res --->", res);
            const url = res?.data?.url || "";
            onUpload(url);
            onSuccess(res, compressed);
            toast("Амжилттай нэмэгдлээ", "success");
          } catch (err) {
            onError(err);
            toast("Upload амжилтгүй боллоо", "error");
          }
        }}
      >
        {files.length === 0 && "+ Зураг"}
      </Upload>
    </div>
  );
};

export default UploadImage;
